import { Box } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { FC } from "react";
import { HOME_SEGMENT_DIMENSIONS } from "./constants";

interface IHomeSegmentContentProps {
  children: any;
}

const CONTAINER_STYLES = (theme: Theme) => ({
  flexGrow: 1,
  height: `calc(100% - ${HOME_SEGMENT_DIMENSIONS(theme).TITLE.HEIGHT}px)`,
  ".MuiTableContainer-root": {
    height: "100%",
    overflow: "overlay",
    border: "none"
  },
  ".MuiTable-root": {
    borderCollapse: "separate"
  },
  ".MuiTableCell-root": {
    padding: "6px 12px",
    color: theme.custom.mainIconColor
  },
  ".MuiTableCell-head": {
    position: "sticky",
    top: 0,
    borderBottom: HOME_SEGMENT_DIMENSIONS(theme).BORDER_BOTTOM,
    backgroundColor: theme.custom.white,
    color: theme.custom.text,
    fontWeight: 600
  }
});

const HomeSegmentContent: FC<IHomeSegmentContentProps> = (props) => {
  const { children } = props;
  const theme = useTheme();
  return <Box sx={CONTAINER_STYLES(theme)}>{children}</Box>;
};

export default HomeSegmentContent;
